import {createAction} from 'redux-actions'

import {TOGGLE_APPROVAL_SIDEBAR} from './types'

export const toggleApprovalSidebar = createAction(TOGGLE_APPROVAL_SIDEBAR)

